import React from "react";
import classNames from "classnames";
import ReactDOM from "react-dom";
import Container from "reactstrap/lib/Container";
import withStyles from "react-jss";
import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";
import Button from "ComponentsUI/Button";

const styles = (theme) => {
	return {
		wrapperList: {
			display: "flex",
			flexWrap: "wrap",
			alignItems: "flex-start",
			justifyContent: "flex-start",
			position: "relative",
		},
		wrapper: {
			position: "relative",
		},
		wrapperContainer: {
			maxHeight: "calc(100vh - 100px)",
			overflow: "auto",
			padding: "32px 0",
		},
		wrapperIsOpen: {},
		close: {
			display: "none",
			cursor: "pointer",
			width: "50px",
			height: "50px",
			zIndex: "100",
			borderRadius: "50%",
			backgroundColor: theme.palette.colors.white,
			boxShadow: `0 2px 4px 0 rgba(44, 29, 93, 0.3)`,
			position: "absolute",
			top: 0,
			transform: "translateY(-50%)",
			right: "20px",
			justifyContent: "center",
			alignItems: "center",
			"& span": {
				color: theme.palette.colors.cloudyBlue,
				fontSize: "16px",
			},
		},
		resetButton: {
			width: "100%",
			marginTop: "16px",
		},
		isProviderCard: {
			justifyContent: "flex-end",
		},
		twoHiddenFilters: {
			justifyContent: "flex-start",
		},
		[`@media (max-width: ${theme.media.sm})`]: {
			wrapper: {
				position: "fixed",
				zIndex: 1,
				bottom: 0,
				left: 0,
				right: 0,
				backgroundColor: "white",
				transform: "translateY(200%)",
				maxHeight: "calc(100vh - 100px)",
				transition: "transform ease-out .3s",
			},
			wrapperIsOpen: {
				transform: "translateY(0)",
			},
			wrapperList: {
				marginTop: 0,
			},
			close: {
				display: "flex",
			},
		},
	};
};

class FilterCollapseWrapper extends React.Component {
	componentDidUpdate(prevProps) {
		if (this.props.open !== prevProps.open) {
			if (this.props.open) {
				disableBodyScroll(this.list);
			} else {
				enableBodyScroll(this.list);
			}
		}
	}

	componentWillUnmount() {
		enableBodyScroll(this.list);
	}

	resetFiltersHandler() {
		this.props.resetFiltersHandler();
		this.props.changeOpenState(false);
	}

	render() {
		let classes = this.props.classes;
		if (!this.props.windowSizes.xs) {
			return (
				<div className={classes.wrapper}>
					<div
						className={classNames(classes.wrapperList, {
							[classes.isProviderCard]: this.props.isProviderCard,
							[classes.twoHiddenFilters]: this.props.twoHiddenFilters,
						})}
					>
						{this.props.children}
					</div>
				</div>
			);
		}

		return ReactDOM.createPortal(
			<div
				className={classNames(classes.wrapper, {
					[classes.wrapperIsOpen]: this.props.open,
				})}
			>
				<div
					className={classes.close}
					onClick={() => {
						this.props.changeOpenState(false);
						this.props.applyButtonClick?.();
					}}
				>
					<span className="icon24 icon-close" />
				</div>
				<div>
					<div className={classes.wrapperContainer}>
						<Container>
							<div className={classes.wrapperList} id={"filtersCollapse"}>
								{this.props.children}
							</div>
							<div className={classes.resetButton}>
								<Button
									fullWidth={true}
									noPaddings={true}
									status={"purple"}
									size="always50"
									typeText={"verybig"}
									onClick={() => {
										this.props.changeOpenState(false);
										this.props.applyButtonClick?.();
									}}
								>
									<span>{this.props.text.APPLY_FILTERS}</span>
								</Button>
							</div>
							{!this.props.withoutResetButton && (
								<div className={classes.resetButton}>
									<Button
										fullWidth={true}
										noPaddings={true}
										status={"grey"}
										size="always50"
										typeText={"verybig"}
										onClick={
											!this.props.disableResetFilterButton
												? () => this.resetFiltersHandler()
												: undefined
										}
										disabled={this.props.disableResetFilterButton}
									>
										<span>{this.props.text.RESET_FILTERS}</span>
									</Button>
								</div>
							)}
						</Container>
					</div>
				</div>
			</div>,
			document.querySelector("#forSelectField")
		);
	}
}

export default withStyles(styles)(FilterCollapseWrapper);
